import type { LabelValueField } from '../components/ProfileView/LabelValueFields/LabelValueFields';

export enum SalaryFrequency {
  Annual = 'ANNUAL',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
}

export type DigitalIdentity = {
  verifiedName?: string | null;
  isVerified: boolean;
};

export type WorkHistory = {
  companyName: string;
  roleTitle: string;
  achievements?: string;
  duration?: string;
};

export type Salary = {
  currency: string;
  expected: string;
  type: SalaryFrequency;
};

export type CredentialsBase = {
  name: string;
  isVerified: boolean;
  labelValueFields?: LabelValueField[];
};

export type Education = CredentialsBase & {
  institute?: string;
  completionLabel?: string;
  highlights?: string;
};

export type Licence = CredentialsBase & {
  issuingOrganisation?: string;
};

export type RightToWork = {
  countryLabel: string;
  statusLabel: string;
  isVerified: boolean;
};

export interface ProfileBase {
  slug: string;
  displayName: string;
  firstName: string;
  lastName: string;
  lastModifiedDurationLabel?: string; // optional as not avail in Candidate Basic Search
  homeLocation: string;
  nationalities?: string;
  hasVerifiedCredentials: boolean;
  digitalIdentity: DigitalIdentity;
  workHistories: WorkHistory[];
  salary?: Salary;
  hasEthicalHiring?: boolean;
  lastInteractionDuration?: string;
}

export interface ProfileCardView extends ProfileBase {
  serviceToken: string;
}
export interface ProfileView extends ProfileBase {
  profileGuid: string;
  personalSummary?: string | null;
  skills?: string[];
  languages?: string[];
  education?: Education[];
  licences?: Licence[];
  rightsToWork?: RightToWork[];
  isOwnedByLoggedInUser?: boolean;
  currentIndustry?: string;
  availability?: string;
  workTypes?: string[];
  locationInProfile?: string;
  locationInCV?: string;
  hasResume?: boolean;
  resume?: Resume;
}

export type Resume = {
  resumeEducation: Array<{
    displayDate: string;
    institutionName: string;
    qualificationName: string;
  }>;
  resumeSkills: string[];
  resumeWorkHistories: Array<{
    companyName: string;
    jobTitle?: string;
    displayDescription: Array<{
      description: string;
      isBullet: boolean;
    }>;
    dateDetails?: string;
  }>;
};
